import { theme } from '@theme';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../style';

type NotesIconProps = {
  notesCount: number;
  click: (e: React.MouseEvent<HTMLSpanElement>) => void;
  color?: string;
  size: number;
};

const NotesIcon: FC<NotesIconProps> = (props) => {
  const getNotesCount = () => (!props.notesCount ? '+' : props.notesCount);
  return (
    <IconWrapper
      {...props}
      data-count={getNotesCount()}
      onClick={props.click}
      data-testid='notes-icon'
    >
      <Icon
        data-testid='notes-button'
        type='notes'
        size={props.size}
        color={props.color ?? theme.palette.blue}
      />
    </IconWrapper>
  );
};

export default NotesIcon;

const IconWrapper = styled.span<NotesIconProps>`
  position: relative;

  &:after {
    content: attr(data-count);
    position: absolute;
    z-index: 1;
    min-width: 16px;
    height: 16px;
    top: -7px;
    right: -4px;
    padding: ${(props) => (props.notesCount === 0 ? '2px 3px' : '3px 4px')};
    border-radius: 3px;
    border: ${(props) => (props.notesCount === 0 ? '1px solid' + props.theme.palette.blue : '0px')};
    background-color: ${(props) =>
      props.notesCount === 0 ? 'white' : props.theme.palette.deepBlue};
    font-size: ${(props) => (props.notesCount === 0 ? theme.typography.h3 : '11px')};
    line-height: 12px;
    color: ${(props) => (props.notesCount === 0 ? props.theme.palette.blue : 'white')};
    font-weight: ${theme.typography.fontWeights.bold};
  }
`;
